/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SEmbedConfig
 */
export interface SEmbedConfig {
    /**
     * 
     * @type {string}
     * @memberof SEmbedConfig
     */
    webUiUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SEmbedConfig
     */
    workspaceKey: string;
    /**
     * 
     * @type {string}
     * @memberof SEmbedConfig
     */
    appKey: string;
}

/**
 * Check if a given object implements the SEmbedConfig interface.
 */
export function instanceOfSEmbedConfig(value: object): value is SEmbedConfig {
    if (!('webUiUrl' in value) || value['webUiUrl'] === undefined) return false;
    if (!('workspaceKey' in value) || value['workspaceKey'] === undefined) return false;
    if (!('appKey' in value) || value['appKey'] === undefined) return false;
    return true;
}

export function SEmbedConfigFromJSON(json: any): SEmbedConfig {
    return SEmbedConfigFromJSONTyped(json, false);
}

export function SEmbedConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SEmbedConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'webUiUrl': json['webUiUrl'],
        'workspaceKey': json['workspaceKey'],
        'appKey': json['appKey'],
    };
}

export function SEmbedConfigToJSON(json: any): SEmbedConfig {
    return SEmbedConfigToJSONTyped(json, false);
}

export function SEmbedConfigToJSONTyped(value?: SEmbedConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'webUiUrl': value['webUiUrl'],
        'workspaceKey': value['workspaceKey'],
        'appKey': value['appKey'],
    };
}

